import { InstallmentPlan } from '../types';

export enum PlanType {
  Custom = 'custom',
  Dynamic = 'dynamic',
}
export interface PaymentPlanFormValues {
  planType: PlanType;
  id: number;
  name: string;
  depositType: string;
  depositAmount: number;
  installmentCount: number;
  frequencyType: string;
  withdrawDayMonthly: string;
  withdrawDayWeekly: string;
  applyDepositPerRegistration: boolean;
  scheduledDates: string[];
}

export enum LoadingType {
  GetPlans,
  CreateOrUpdatePlan,
}

export interface PaymentPlansState {
  loading: {
    [LoadingType.GetPlans]: boolean;
    [LoadingType.CreateOrUpdatePlan]: boolean;
    error?: string;
    id?: number;
  };
  plans: InstallmentPlan[];
  isOpen: boolean;
  formValues: PaymentPlanFormValues | null;
  errors: Record<string, string[]>; // key is the field name, value is the error message
}

export const defaultPlan: Partial<InstallmentPlan> = {
  name: '',
  enabled: true,
  depositType: 'amount',
  depositAmount: 0,
  installmentCount: 0,
  frequencyType: 'custom',
  frequencyAmount: 1,
  withdrawDay: '1',
  withdrawBasedOnCheckout: false,
  applyDepositPerRegistration: false,
  scheduledDates: [],
};
